import Loader from "react-loader-spinner";
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Accordion, Card, Table } from 'react-bootstrap';
import { getCampaignList, getCampaignCustomerList, getCustomerEvents, searchCustomer, verifyEvent, setCustomerSearchFilter, setPreCustomerSearchFilter } from '../store/api/CustomerApi';
import { AppIndicator, Calendar2Event, CaretLeftFill, CaretLeftSquare, CaretRightFill, Check2, CheckLg, ClipboardData, ClipboardPlus, ColumnsGap, Display, EmojiFrown, EmojiFrownFill, LayoutWtf, Newspaper, PersonBadge, PersonSquare, Phone, UiChecksGrid, XDiamondFill } from 'react-bootstrap-icons';
import { BarChart, Bar, YAxis, XAxis, ResponsiveContainer, Legend, CartesianGrid, Tooltip, Rectangle, PieChart, Pie, Cell } from "recharts";
import { getCustomerCountReport } from '../../Services/store/api/CustomerApi';
import TableRow from "../Components/TableRow";
import { Link } from "react-router-dom";
import { getMyCommandsCount } from "../store/api/CommandsAPI";
import { getMyRemindersCount } from "../store/api/ReminderAPI";
import ModalSearchReminders from "../pages/ModalSearchReminders";
import { getActiveSubsystems } from "../../store/api/CommonFunctions";
const HomePage = () => {
    const currPage = useRef(1);
    const totalPage = useRef(0);
    const openAcc = useRef(true);
    const searchData = useRef({});
    const history = useHistory();
    const dispatch = useDispatch();
    const [remindersCount, setRemCount] = useState(0);
    const [customerList, setCustomerList] = useState([]);
    const [showSearchReminderModal, setShowSearchReminderModal] = useState(false);
    const showSearchReminders = () => {
        setShowSearchReminderModal(true);
    }
    const { eventList, campaignList, countList, myCommandsCount } = useSelector(state => {
        return {
            eventList: state.customerDataReducer.customerEventList,
            myCommandsCount: state.CommandsReducer.myCommandsCount,
            campaignList: state.customerDataReducer.campaignList,
            countList: state.customerDataReducer.customerCountReport
        }
    });
    const jobCountList = countList ? countList.filter(c => c.ReportType === "JobCount") : [];
    const statusCount = countList ? countList.filter(c => c.ReportType === "StatusCount") : [];
    const howToKnowCount = countList ? countList.filter(c => c.ReportType === "HowToKnow") : [];
    const unwillingCount = countList ? countList.filter(c => c.ReportType === "Unwillingness") : [];
    const customerCount = countList ? countList.filter(c => c.ReportType === "CustomerCount") : [];
    const purchasePossibility = countList ? countList.filter(c => c.ReportType === "PurchasePossibility") : [];
    const COLORS = ['#6200ff', 'rgb(70, 141, 148)', 'rgb(201, 69, 58)', '#FF8042', 'rgb(201, 69, 58)', 'rgb(115, 57, 141)'];
    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = (props) => {
        const { cx, cy, midAngle, innerRadius, outerRadius, percent } = props;
        const radius = innerRadius + (outerRadius - innerRadius) + 25;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="red" style={{ fontSize: "10px" }} textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(1)}%`}
            </text>
        );
    };
    const totalCount = eventList && eventList.TotalCount ? Number(eventList.TotalCount) : 0;

    if (totalPage.current < 1) {
        totalPage.current = Math.floor(totalCount / 10) + ((totalCount % 10) > 0 ? 1 : 0);
    }
    const searchEvents = (reset) => {
        if (reset) {
            currPage.current = 1;
            totalPage.current = 0;
        }
        searchData.current.MyEvents = true;
        searchData.current.HasNextDate = true;
        searchData.current.Skip = currPage.current - 1;
        searchData.current.Take = 5;
        dispatch(getCustomerEvents(searchData.current));
    }
    const changePage = (inc) => {
        if (inc) {
            currPage.current++;
        }
        else {
            currPage.current--;
        }
        searchEvents();
    }
    const tableColes = [
        { colTitle: "تاریخ پیگیری", colName: "pNextDate", showInMobile: true },
        { colTitle: "شرح رویداد", colName: "Description", showInMobile: true, maxTextLength: 40, colType: "string", hasTooltip: true },
        { colTitle: "نوع رویداد", colName: "EventTypeStr", showInMobile: false }

    ]
    const tableRowButtons = [
        {
            title: "بررسی شد", type: "common", icon: <CheckLg color="green" size={17} className="rowBtn" />, onclick: (item) => {
                dispatch(verifyEvent(item.ID, searchEvents))
            }
        }

    ]
    const showCampaign = (id) => {
        openAcc.current = false;
        history.push("/CRM/AddEditSaleCampaign/" + id);
    }
    const onAccardionClick = (id) => {

        if (!openAcc.current) {
            openAcc.current = true;
            return;
        }
        setCustomerList("PENDING");
        //openedAcc.current = true;
        getCampaignCustomerList(id, setCustomerList);

    }
    const showCustomer = (item) => {
        if (item.CustOrPreCust === "مشتری بالقوه") {
            history.push("/CRM/AddEditPreCustomer/" + item.ID);
        }
        else {
            history.push("/CRM/AddEditCustomer/" + item.ID);
        }
    }
    const renderLegend = (props) => {
        const { payload } = props;
        return (
            <Fragment>
                {
                    payload.map((entry, index) => (
                        <span key={`item-${index}`} style={{ color: `${entry.color}`, fontSize: "11px" }}>
                            <div style={{ backgroundColor: `${entry.color}`, width: "10px", height: "10px", display: "inline-block" }}></div>
                            &nbsp;{entry.value.replace("PreCustomerCount", "مشتری بالقوه").replace("CustomerCount", "مشتری")}
                        </span>
                    ))
                }
            </Fragment>
        );
    }
    const goToSearchCustomer = (payload) => {
        let filterData = {};
        const dataKey = payload.tooltipPayload ? payload.tooltipPayload[0].dataKey : payload.dataKey;
        switch (payload.ReportType) {
            case "JobCount":
                filterData.JobId = payload.PreCustomerLabelID;
                filterData.Job = payload.CustomerLabelID;
                break;
            case "StatusCount":
                if (dataKey === "PreCustomerCount") {
                    filterData.StatusID = payload.PreCustomerLabelID;
                }
                else if (dataKey === "CustomerCount")
                    filterData.StatusID = payload.CustomerLabelID;
                break;
            case "HowToKnow":
                filterData.HowToKnow = payload.PreCustomerLabelID;
                break;
            case "Unwillingness":
                filterData.Unwillingness = payload.PreCustomerLabelID;
                break;
            case "PurchasePossibility":
                filterData.PurchasePossibility = payload.PreCustomerLabelID.split('-')[0];
                filterData.PurchasePossibilityTo = payload.PreCustomerLabelID.split('-')[1];
            default:
                break;
        }
        if (dataKey === "PreCustomerCount") {
            filterData.pagesize = 10;
            dispatch(setPreCustomerSearchFilter(filterData, () => history.push("/CRM/SearchPreCustomer")));
        }
        else if (dataKey === "CustomerCount") {
            dispatch(setCustomerSearchFilter(filterData, () => history.push("/CRM/SearchCustomer")));

        }

    }
    const getPath = (x, y, width, height) => `M${x},${y + height}
    C${x + width / 3},${y + height} ${x + width / 2},${y + height / 3} ${x + width / 2}, ${y}
    C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${x + width}, ${y + height}
    Z`;

    const TriangleBar = (props) => {
        const { fill, x, y, width, height, payload, tooltipPayload } = props;

        return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} style={{ cursor: "pointer" }} onClick={() => goToSearchCustomer({ ...payload, tooltipPayload })} />;
    };

    // const CustomTooltip = (props) => {
    //     const { active, payload } = props;
    //     console.log(payload);
    //     if (active && payload && payload.length) {
    //         return (
    //             <div>
    //                 {
    //                     payload.map((item, i) =>
    //                         <div key={i} style={{ textAlign: "right", color: "black" }}>
    //                             <div style={{ backgroundColor: `${item.fill}`, width: "10px", height: "10px", display: "inline-block" }}></div>
    //                             &nbsp;
    //                             {item.value}
    //                         </div>)
    //                 }
    //             </div>

    //         );
    //     }
    //     return null;
    // }
    // const TooltipCursor = (props) => {
    //     const { x, y, width, height } = props;
    //     return <Rectangle fill="blue" stroke="blue" x={x} y={y} width={width} height={height} style={{ opacity: "0.3" }} />;
    // }
    const DefaultBar = (props) => {
        const { x, y, width, height, fill, payload, tooltipPayload } = props;
        return <Rectangle fill={fill} x={x} y={y} width={width} height={height} radius={1} onClick={() => goToSearchCustomer({ ...payload, tooltipPayload })} style={{ cursor: "pointer" }} />;
    }
    const BarBar = (props) => {
        const { x, y, width, height, fill, payload, tooltipPayload } = props;
        return <Rectangle fill={fill} stroke="blue" x={x} y={y} width={width} height={height} radius={1} style={{ opacity: "0.4", cursor: "pointer" }} onClick={() => goToSearchCustomer({ ...payload, tooltipPayload })} />;
    }
    const BarBar2 = (props) => {
        const { x, y, width, height, fill, payload, tooltipPayload } = props;
        return <Rectangle fill={fill} stroke="blue" x={x} y={y} width={width} height={height} radius={5} style={{ opacity: "0.6", cursor: "pointer" }} onClick={() => goToSearchCustomer({ ...payload, tooltipPayload })} />;
    }
    useEffect(() => {
        document.body.classList = "";
        dispatch(getCampaignList({}));
        dispatch(getCustomerCountReport());
        dispatch(getMyCommandsCount());
        getMyRemindersCount(false, setRemCount);
        searchEvents(true);
    }, []);
    return (
        <div>
            <ModalSearchReminders showModal={showSearchReminderModal} setShow={setShowSearchReminderModal} isRead={false} />
            <img style={{ marginTop: "10px", marginBottom: "10px" }} alt="" />
            <div className="container-fluid">
                <br />
                <div className='row'>
                    <div className="col-md-2" style={{ height: "300px" }}>
                        <Card className="mt-1" style={{ background: "rgb(246 246 247)" }}>
                            <Card.Header style={{ background: "rgb(140 131 186)", color: "whitesmoke" }}>
                                یادآوری ها
                            </Card.Header >
                            <Card.Body style={{ height: "57px" }}>
                                <Link to="#" onClick={showSearchReminders}>{remindersCount && remindersCount}</Link>
                            </Card.Body>
                        </Card>
                        <Card className="mt-1" style={{ background: "rgb(246 246 247)", color: "black" }}>
                            <Card.Header style={{ background: "rgb(55 146 202)", color: "whitesmoke" }}>
                                مشتریان
                            </Card.Header >
                            <Card.Body style={{ height: "57px" }}>
                                <Link to="/CRM/SearchCustomer">
                                    {customerCount && Array.isArray(customerCount) && customerCount.length > 0 && customerCount.find(c => c.CustomerCount === 1).ReportLabel + 'مشتری'}
                                </Link>
                            </Card.Body>
                        </Card>
                        <Card className="mt-1" style={{ background: "rgb(246 246 247)", color: "black" }}>
                            <Card.Header style={{ background: "rgb(190 123 137)", color: "whitesmoke" }}>
                                مشتریان بالقوه
                            </Card.Header >
                            <Card.Body style={{ height: "57px" }}>
                                <Link to="/CRM/SearchPreCustomer">
                                    {customerCount && Array.isArray(customerCount) && customerCount.length > 0 && customerCount.find(c => c.PreCustomerCount === 1).ReportLabel + 'مشتری'}
                                </Link>
                            </Card.Body>
                        </Card>
                        <Card className="mt-1" style={{ background: "rgb(246 246 247)", color: "black" }}>
                            <Card.Header style={{ background: "rgb(134 153 165)", color: "whitesmoke" }}>
                                دستور کارهای من
                            </Card.Header >
                            <Card.Body style={{ height: "57px" }}>
                                <Link to="/UserDashboard">
                                    {myCommandsCount && myCommandsCount !== "PENDING" && myCommandsCount + " دستور کار"}
                                </Link>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className='col-md-4'>
                        <Card style={{ background: "rgb(246 246 247)", color: "black" }}>
                            <Card.Header style={{ background: "rgb(190 184 183)" }}>
                                <Card.Title style={{ textAlign: "right" }}><Calendar2Event size={18} color="#573030" />&nbsp;&nbsp;رویدادهای قابل پیگیری</Card.Title>
                            </Card.Header >
                            <Card.Body style={{ height: "350px", paddingLeft: "5px", paddingRight: "5px" }}>
                                <Table responsive style={{ minHeight: "250px", borderCollapse: "separate", border: "none", borderSpacing: "1px 3px" }} >
                                    <thead style={{ backgroundColor: "#b498a4" }}>
                                        <tr>
                                            <th>تاریخ پیگیری</th>
                                            <th>شرح رویداد</th>
                                            {
                                                window.innerWidth >= 414 &&
                                                <Fragment>
                                                    <th>نوع رویداد</th>
                                                    <th></th>
                                                </Fragment>
                                            }
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {eventList === "PENDING" &&
                                            <tr>
                                                <td colSpan={6} style={{ textAlign: "center" }}>
                                                    <Loader type="BallTriangle" color="#bb1370" height={30} />
                                                </td>
                                            </tr>
                                        }
                                        {
                                            eventList?.Data && Array.isArray(eventList.Data) &&
                                            eventList.Data.map((item, i) =>
                                                <TableRow key={i} row={item} buttons={tableRowButtons} indx={i} cols={tableColes} style={{ backgroundColor: item.BackgroundColor }} />)
                                        }
                                    </tbody>
                                </Table>
                                <div style={{ textAlign: "center" }}>
                                    <button className="btn btn-block" style={{ padding: "2px", marginLeft: "3px" }} title='صفحه قبل' disabled={currPage.current === 1} onClick={() => { changePage(false) }}><CaretRightFill size={25} /></button>
                                    <span>{currPage.current + " از " + totalPage.current}</span>
                                    <button className="btn btn-block" style={{ padding: "2px", marginRight: "3px" }} title='صفحه بعد' disabled={currPage.current === totalPage.current} onClick={() => changePage(true)}><CaretLeftFill size={25} /></button>
                                </div>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className='col-md-6'>
                        <Card>
                            <Accordion>
                                <Card>
                                    <Card.Header style={{ backgroundColor: "rgb(194 180 209)", textAlign: "right", fontWeight: "bold" }}>
                                        <Card.Title>
                                            <XDiamondFill size={18} color="#7a4b87" />&nbsp; کمپین های فروش
                                        </Card.Title>
                                    </Card.Header>
                                    <Card.Body style={{ height: "350px", overflowY: "scroll" }}>
                                        {campaignList && Array.isArray(campaignList) && campaignList.map((item, i) =>
                                            <Fragment key={i}>
                                                <Accordion.Toggle as={Card.Header} eventKey={i + 1} onClick={() => onAccardionClick(item.ID)}
                                                    style={{
                                                        backgroundColor: `rgb(139 131 223)`,
                                                        boxShadow: "2px 2px 5px",
                                                        marginTop: "2px",
                                                        textAlign: "right",
                                                        fontWeight: "bold",
                                                        lineHeight: 2
                                                    }}>
                                                    <ColumnsGap color='#9b009f' size={18} />
                                                    &nbsp;&nbsp;
                                                    {item.CampaignName} &nbsp;<CaretLeftSquare className='rowBtn' size={19} color='#430e6c' onClick={() => showCampaign(item.ID)} />
                                                    <div style={{
                                                        float: "left",
                                                        border: "1px solid rgb(210 224 238)",
                                                        width: "120px",
                                                        borderRadius: "3px",
                                                        boxShadow: "1px 1px 5px",
                                                        backgroundColor: "rgb(232 218 243)",
                                                        paddingRight: "3px"
                                                    }}><UiChecksGrid />&nbsp;<span style={{ color: "#473b3b" }}>{item.StageName}</span></div>

                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey={i + 1}>
                                                    <Card.Body style={{ padding: 0 }}>
                                                        <Table className="fixedTable mt-1" responsive={true} >
                                                            <thead>
                                                                <tr >
                                                                    <th style={{ width: "28%" }}>نام مشتری</th>
                                                                    <th style={{ width: "20%" }}>تلفن</th>
                                                                    <th style={{ width: "22%" }}>موبایل</th>
                                                                    <th style={{ width: "15%" }}>نوع</th>
                                                                    <th style={{ width: "15%" }}>وضعیت</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {customerList && Array.isArray(customerList) &&
                                                                    customerList.map((item, i) =>
                                                                        <tr key={i} className="resultTableRow" onClick={() => showCustomer(item)}>
                                                                            <td style={{ width: "30%" }}>{item.Name.substring(0, 30)}</td>
                                                                            <td style={{ width: "20%" }}>{item.Phone === "" || !item.Phone ? "--" : item.Phone.substring(0, 12)}</td>
                                                                            <td style={{ width: "20%" }}>{item.Mobile === "" || !item.Mobile ? "--" : item.Mobile.substring(0, 12)}</td>
                                                                            <td style={{ width: "15%" }}>{item.CustOrPreCust}</td>
                                                                            <td style={{ width: "15%" }}>{item.Status ?? "--"}</td>
                                                                        </tr>)
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Fragment>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Accordion>
                        </Card>
                    </div>
                </div>
                <div className="row mt-3">
                    <div className='col-md-8'>
                        <Card style={{ background: "rgb(246 246 247)", color: "black", height: "300px" }}>
                            <Card.Header style={{ background: "rgb(199 161 151)" }}>
                                <Card.Title style={{ textAlign: "right" }}><LayoutWtf size={20} color="#6b2d0a" /><PersonBadge size={20} color="#6b2d0a" />&nbsp;مشتریان/بالقوه به تفکیک رسته شغلی</Card.Title>
                            </Card.Header >
                            <Card.Body style={{ paddingRight: "0", paddingBottom: "5px" }}>
                                <ResponsiveContainer width="100%" height="100%" className="barChart" debounce={300}>
                                    {jobCountList &&
                                        <BarChart data={jobCountList} width={1000}>
                                            <XAxis dataKey="ReportLabel" style={{ fontSize: "9px" }} reversed={true} minTickGap={1} width={100} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" />
                                            <CartesianGrid />
                                            <Bar dataKey="CustomerCount" fill="#73398d" shape={<DefaultBar />} label={{ position: 'top' }} isAnimationActive={false} />
                                            <Bar dataKey="PreCustomerCount" fill="#c9453a" shape={<DefaultBar />} label={{ position: 'top' }} isAnimationActive={false} />
                                            {/* <Tooltip content={CustomTooltip} cursor={<TooltipCursor />} /> */}
                                            <Legend align="center" content={renderLegend} verticalAlign="top" />
                                        </BarChart>
                                    }
                                </ResponsiveContainer>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className='col-md-4'>
                        <Card style={{ background: "rgb(246 246 247)", color: "black", height: "300px" }}>
                            <Card.Header style={{ background: "rgb(213 127 139)" }}>
                                <Card.Title style={{ textAlign: "right" }}><AppIndicator size={20} color="#672558" />&nbsp;&nbsp;احتمال خرید مشتریان بالقوه</Card.Title>
                            </Card.Header >
                            <Card.Body >
                                {purchasePossibility && Array.isArray(purchasePossibility) && purchasePossibility.length > 0 &&
                                    <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>
                                        <PieChart >
                                            <Pie nameKey="ReportLabel" data={purchasePossibility} isAnimationActive={false}
                                                dataKey="PreCustomerCount" cx="50%" cy="47%" outerRadius={90} fill="#8884d8" label={renderCustomizedLabel}>
                                                {purchasePossibility.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS[index]} style={{ cursor: "pointer" }} onClick={() => goToSearchCustomer({ ...entry, dataKey: "PreCustomerCount" })} />
                                                ))}
                                            </Pie>
                                            <Legend align="center" state={{ boxHeight: 20 }} />
                                        </PieChart>
                                    </ResponsiveContainer>
                                }
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className='col-md-6'>
                        <Card style={{ background: "rgb(246 246 247)", color: "black", height: "300px" }}>
                            <Card.Header style={{ background: "rgb(203 178 197)" }}>
                                <Card.Title style={{ textAlign: "right" }}><Display color="#6b2330" /><Phone color="#6b2330" />مشتریان بالقوه به تفکیک نحوه آشنایی</Card.Title>
                            </Card.Header >
                            <Card.Body style={{ paddingRight: "0", paddingBottom: "5px" }}>
                                {howToKnowCount && howToKnowCount.length > 0 &&
                                    <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>

                                        <BarChart data={howToKnowCount} width={1000}>
                                            <XAxis dataKey="ReportLabel" style={{ fontSize: "9px" }} reversed={true} minTickGap={1} width={100} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" />
                                            <CartesianGrid />
                                            <Bar dataKey="PreCustomerCount" fill="#73398d" shape={<BarBar />} label={{ position: 'top' }} isAnimationActive={false} />
                                        </BarChart>

                                    </ResponsiveContainer>
                                }
                            </Card.Body>
                        </Card>
                    </div>
                    <div className='col-md-6'>
                        <Card style={{ background: "rgb(246 246 247)", color: "black", height: "300px" }}>
                            <Card.Header style={{ background: "rgb(158 190 189)" }}>
                                <Card.Title style={{ textAlign: "right" }}><PersonSquare size={18} color="#015501" /><ClipboardData color="#015501" />&nbsp;مشتریان/بالقوه به تفکیک وضعیت</Card.Title>
                            </Card.Header >
                            <Card.Body style={{ paddingRight: "0", paddingBottom: "5px" }}>
                                <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>
                                    {statusCount &&
                                        <BarChart data={statusCount}>
                                            <XAxis dataKey="ReportLabel" style={{ fontSize: "9px" }} reversed={true} minTickGap={1} width={100} />
                                            <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" />
                                            <CartesianGrid />
                                            <Bar dataKey="CustomerCount" fill="#468d94" shape={<TriangleBar />} label={{ position: 'top' }} isAnimationActive={false} />
                                            <Bar dataKey="PreCustomerCount" fill="#d56806" shape={<TriangleBar />} label={{ position: 'top' }} isAnimationActive={false} />
                                            {/* <Tooltip content={CustomTooltip} cursor={<TooltipCursor />} /> */}
                                            <Legend align="center" content={renderLegend} verticalAlign="top" />
                                        </BarChart>
                                    }
                                </ResponsiveContainer>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="row mt-2">
                        <div className='col-md-6' style={{ paddingLeft: 0 }}>
                            <Card style={{ background: "rgb(246 246 247)", color: "black", height: "300px" }}>
                                <Card.Header style={{ background: "rgb(188 200 225)" }}>
                                    <Card.Title style={{ textAlign: "right" }}><EmojiFrown size={20} color="#3b25a9" />&nbsp;&nbsp;مشتریان بالقوه به تفکیک عدم تمایل</Card.Title>
                                </Card.Header >
                                <Card.Body style={{ paddingRight: "0", paddingBottom: "5px" }}>
                                    {unwillingCount && unwillingCount.length > 0 &&
                                        <ResponsiveContainer width="105%" height="100%" className="barChart" debounce={300}>

                                            <BarChart data={unwillingCount} width={1000}>
                                                <XAxis dataKey="ReportLabel" style={{ fontSize: "9px" }} reversed={true} minTickGap={1} width={100} />
                                                <YAxis dx={15} style={{ fontSize: "10px" }} orientation="right" />
                                                <CartesianGrid />
                                                <Bar dataKey="PreCustomerCount" fill="blue" shape={<BarBar2 />} label={{ position: 'top' }} isAnimationActive={false} />

                                            </BarChart>

                                        </ResponsiveContainer>
                                    }
                                </Card.Body>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default HomePage;